export enum RateType {
  Optimized = 'Optimized',
  Fixed = 'Fixed',
}
